import Vue from 'vue';
import auth from './auth';
import missionVuex from './missions';

const state = {
  paths: {},
  promoCodes: {},
  roomId: null,
};

const actions = {
  FETCH_PATHS: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }
    let searchedPaths = await kuzzle.query({
      controller: 'document',
      action: 'search',
      index: index,
      collection: 'paths',
      from: 0,
      size: 100,
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
    });

    console.log('searchedPaths:', searchedPaths.result.hits.length);
    commit('RESET_PATHS');

    searchedPaths.result.hits.forEach((p) => {
      commit('ADD_PATH', p);
    });
    // for (; searchedPaths; searchedPaths = await searchedPaths.result.next()) {
    //   searchedPaths.result.hits.forEach(path => {
    //     commit('ADD_PATH', path);
    //   });
    // }
  },
  FETCH_PROMOCODES: async ({ commit }, { kuzzle }) => {
    let searchedCodes = await kuzzle.document.search(
      'public',
      'promocodedescription',
      {}
    );

    for (; searchedCodes; searchedCodes = await searchedCodes.next()) {
      searchedCodes.hits.forEach((pc) => {
        commit('ADD_PROMO_CODE', pc);
      });
    }
  },
  SUBSCRIBE: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }

    const roomId = await kuzzle.realtime.subscribe(
      index,
      'paths',
      {
        loggedAsUser:
          auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      },
      (notification) => {
        switch (notification.action) {
          case 'update':
            commit('UPDATE_PATH', {
              pathId: notification.result._id,
              pathPayload: notification.result._source,
            });
            break;
          case 'delete':
            commit('DELETE_PATH', notification.result._id);
            break;
          case 'create':
            commit('ADD_PATH', notification.result);
            break;
        }
      },
      {
        scope: 'all',
      }
    );
    commit('SET_ROOM_ID', roomId);
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  //Must provide object as first argument but no need commit or dispatch here...
  CREATE_PATH: async ({}, { newPathPayload, index, kuzzle }) => {
    if (!index) {
      return;
    }

    let pathCreated = await kuzzle.query({
      controller: 'document',
      action: 'create',
      index: index,
      collection: 'paths',
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      body: newPathPayload,
    });
    return pathCreated.result;
  },
  DELETE_PATH: async ({}, { pathId, index, kuzzle }) => {
    if (!index) {
      return;
    }
    await kuzzle.document.delete(index, 'paths', pathId);
  },
  UPDATE_PATH: async ({}, { pathId, pathPayload, index, kuzzle }) => {
    if (!index) {
      return;
    }
    if (pathPayload.hasOwnProperty('pictures')) {
      pathPayload.pictures.forEach(p => { delete p.dataUrl; });
    }
    return await kuzzle.document.update(index, 'paths', pathId, pathPayload, {source:true});
  },
  REMOVE_MISSION: async (
    { state },
    { pathId, missionId, index, kuzzle, indexKey }
  ) => {
    const missions = [...state.paths[pathId].missions.map((m) => ({ ...m }))];

    if (indexKey) {
      missions.splice(indexKey, 1);
      await kuzzle.document.update(index, 'paths', pathId, {
        missions: missions,
      });
    } else {
      let newMissionsList = missions.filter(
        (mission) => mission.missionId !== missionId
      );
      await kuzzle.document.update(index, 'paths', pathId, {
        missions: newMissionsList,
      });
    }
  },
  ADD_MISSIONS: async (
    { commit, state },
    {
      pathId,
      missionsIds,
      index,
      kuzzle,
      isCopying,
      originalPathId,
      originalMissionId,
    }
  ) => {
    let extraMissions;
    if (!isCopying) {
      extraMissions = missionsIds.map((missionId) => ({
        missionId,
        extraRewards: [],
        isPublished: true,
      }));
    } else {
      extraMissions = missionsIds.map((missionId) => {
        const originalMission = state.paths[originalPathId].missions.filter(
          (m) => {
            return m.missionId === originalMissionId;
          }
        )[0];
        return {
          missionId,
          geolocationInPath: originalMission.hasOwnProperty('geolocationInPath')
            ? originalMission.geolocationInPath
            : null,
          isActive: originalMission.hasOwnProperty('isActive')
            ? originalMission.isActive
            : true,
          extraRewards: originalMission.extraRewards,
          isPublished: true,
        };
      });
    }
    const actualMissions = state.paths[pathId].missions;

    const missions = [
      ...(actualMissions ? actualMissions.map((m) => ({ ...m })) : []),
      ...extraMissions,
    ];

    await kuzzle.document.update(index, 'paths', pathId, {
      missions,
    });
    return { status: 'success' };
  },
  UPDATE_MISSION: async (
    { state },
    { pathId, missionId, index, kuzzle, payload, indexKey }
  ) => {
    console.log('action UPDATE_MISSION');
    const missions = [...state.paths[pathId].missions.map((m) => ({ ...m }))];

    const idx =
      indexKey || missions.findIndex((m) => m.missionId === missionId);

    if (idx === -1) {
      return;
    }

    missions[idx] = {
      ...missions[idx],
      ...payload,
    };
    await kuzzle.document.update(index, 'paths', pathId, {
      missions,
    });
  },
  TRANSLATE_PATH: async (
    {},
    { index, pathId, originLanguage, targetLanguage, kuzzle }
  ) => {
    console.log('action TRANSLATE_PATH');
    const res = await kuzzle.query({
      controller: 'translate',
      action: 'document',
      body: {
        index: index,
        collection: 'paths',
        docId: pathId,
        targetLang: targetLanguage,
        originLang: originLanguage,
      },
    });
  },
  ASK_FOR_A_GENERATION: async (state, { place, time, theme, email, kuzzle }) => {
    return await kuzzle.query({
      controller: 'explorama-plugin/generation-ai',
      action: 'askForAGeneration',
      body: {
        place: place,
        time: time,
        theme: theme,
        email: email,
      },
    });
  },
};

const mutations = {
  RESET_PATHS: (state) => {
    state.paths = {};
  },
  ADD_PATH: (state, path) => {
    Vue.set(state.paths, path._id, path._source);
  },
  ADD_PROMO_CODE: (state, pc) => {
    Vue.set(state.promoCodes, pc._id, pc._source);
  },
  UPDATE_PATH: (state, { pathId, pathPayload }) => {
    Vue.set(state.paths, pathId, pathPayload);
  },
  // utilisé qq part?
  TRANSLATE_PATH: (state, { pathId, pathPayload }) => {
    console.log('mute TRANSLATE_PATH');
    Vue.set(state.paths, pathId, pathPayload);
  },
  DELETE_PATH: (state, pathId) => {
    if (!state.paths[pathId]) {
      return;
    }
    Vue.delete(state.paths, pathId);
  },
  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

const getters = {
  getPathByName: (state) => {
    return (pathName) => {
      const path = Object.values(state.paths).filter((path) => {
        return path.name === pathName;
      });
      return path[0];
    };
  },
  getPathById: (state) => {
    return (pathId) => {
      if (!Object.keys(state.paths).includes(pathId)) {
        return null;
      }
      const path = state.paths[pathId];
      return path;
    };
  },
  getPathEmptyId: (state) => {
    return () => {
      let emptyPath = '';
      Object.keys(state.paths).forEach((id) => {
        if (state.paths[id].name.fr === '' && state.paths[id].name.en === '') {
          emptyPath = id;
        }
      });

      return emptyPath;
    };
  },
  getPath: (state) => {
    return (pathName) => {
      const path = Object.values(state.paths).filter((path) => {
        return path.name === pathName;
      });
      return path[0];
    };
  },
  getPromoCodes: (state) => {
    return state.promoCodes;
  },
  getPathsAccess: (state) => {
    const accessByPath = {};
    for (const [pathId, { access }] of Object.entries(state.paths)) {
      accessByPath[pathId] = access;
    }
    return accessByPath;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
